import React, { useEffect, useState } from 'react';
import format from 'date-fns/format';
import SarasInput from '../textField/SarasInput';
import SarasDatePicker from './SarasDatePicker';
import { parseDate, isValidDate } from '../../../helper/uiFunctions';
import coreSettings from '../../../helper/coreSetting';
import SarasPopup from '../../container/popup/SarasPopup';
import SarasDialog from '../../container/popup/SarasDialogDefAction';
import SarasTrans from '../../notifications/SarasTrans';
import SarasDateQPMenu from './SarasDateQPMenu';

const SarasDateRangePicker = ({ 
    value, buttonClassName, deviceInfo,
    onlyIcon, titleClassName, onChange }) => {
  const [customMode, setCustomMode] = useState(false);
  const [rangePickerRef, setRangePickerRef] = useState(null);
  const [range, setRange] = useState(
    value || {
      startDate: new Date(),
      endDate: new Date(),
    }
  );

  const synchDateCriteria = () => {
      if(value
      ) {
          setRange(value);
      }
  };

  useEffect(synchDateCriteria, [value]);

  // For temporary selection in custom mode
  const [tempRange, setTempRange] = useState(range);

  const value1Changed = (e) => {
    if(isValidDate(e.currentTarget.value)) {
      dpValue1Changed(null, e.currentTarget.value);
    }
  }

  const value2Changed = (e) => {
    if(isValidDate(e.currentTarget.value)) {
      dpValue2Changed(null, e.currentTarget.value);
    }
  }

  const dpValue1Changed = (dp, value) => {
    setTempRange(prev => ({
      ...prev,
      startDate: parseDate(value).toDate(),
    }));
  };

  const dpValue2Changed = (dp, value) => {
    setTempRange(prev => ({
      ...prev,
      endDate: parseDate(value).toDate(),
    }));
  };

  const handleCustomPickerClosed = () => {
    setCustomMode(false);
  }

  const handleApply = () => {
    let { startDate, endDate } = tempRange;
    // If startDate is after endDate, swap them
    if (startDate > endDate) {
      [startDate, endDate] = [endDate, startDate];
    }
    const newRange = { startDate, endDate };
    setRange(newRange);
    setCustomMode(false);
    if (onChange) onChange(newRange);
  };

  const handleQuickSelect = (anchorRef, newRange, isCustomMode) => {
    setCustomMode(isCustomMode);
    setRangePickerRef(anchorRef);

    if(newRange.startDate && newRange.endDate) {
      setRange(newRange);
      if (onChange) onChange(newRange);
    }
    else {
      setTempRange(range);
    }
  };

  return (
    <>
      <SarasDateQPMenu value={range} allowCustomRange
        buttonClassName={buttonClassName}
        titleClassName={titleClassName} 
        onlyIcon={onlyIcon}
        deviceInfo={deviceInfo}
        onChange={handleQuickSelect} />
      {customMode && (
        <SarasPopup anchorRef={rangePickerRef} open={true} 
          onClose={handleCustomPickerClosed}
          >
          <SarasDialog formStyle={{ width: '300px', height:'175px' }} 
              contentStyle={{ height:'85px', overflow:'hidden' }}  title={<SarasTrans value='Select Date Range' />} 
              actionName="Apply" actionFunction={handleApply}
              cancelName='Cancel' cancelFunction={handleCustomPickerClosed} >
            <div className='uiBox uiFormMini'>
              <div className='uiFlexBox'>
                <span className="uiLbl uiBold"><SarasTrans value='Start Date' /></span>
                <SarasInput autofocus value={tempRange.startDate ? `${format(tempRange.startDate, coreSettings.currentDateLocale)}` : ''} onSearchAsKeyed={value1Changed} />
                <SarasDatePicker className='uiHideMuiDatepickerTxt' onChange={dpValue1Changed} />
              </div>
              <div className='uiFlexBox'>
                <span className="uiLbl uiBold"><SarasTrans value='End Date' /></span>
                <SarasInput value={tempRange.endDate ? `${format(tempRange.endDate, coreSettings.currentDateLocale)}` : ''} onSearchAsKeyed={value2Changed} />
                <SarasDatePicker className='uiHideMuiDatepickerTxt' style={{ width: '50px' }} onChange={dpValue2Changed} />
              </div>
            </div>
          </SarasDialog>
        </SarasPopup>
      )}
    </>
  );
};

export default SarasDateRangePicker;
